import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <XCircle size={80} className="mx-auto text-[#FF4D4D] mb-6" />
      <h1 className="text-3xl font-black text-[#262626] mb-2">Paiement annulé</h1>
      <p className="text-[#595959] mb-6">Vous avez annulé le paiement. Votre panier a été conservé pour vous.</p>
      <div className="flex gap-3 justify-center">
        <Button onClick={() => navigate('/panier')} className="bg-[#00847A] hover:bg-[#006B63] text-white rounded-full h-11 px-6 font-semibold">
          Retour au panier
        </Button>
        <Link to="/" className="inline-flex items-center text-[#595959] hover:text-[#00847A] px-5 py-2 text-sm font-semibold">
          Continuer mes achats
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
